export default __webpack_public_path__ + "1Mz2jS3-flow.svg";